import PatientCodeStatus from './PatientCodeStatus';

export default PatientCodeStatus;
